import React, { useState } from 'react';
import api from '../services/api';

/**
 * Ações de compartilhamento do histórico consolidado da criança: imprimir o
 * documento (base + linha do tempo de todas as categorias) ou enviar ao
 * responsável em PDF. O lançamento datado em si é feito por campo
 * (ver HistoricoCampo, sob cada item de Desenvolvimento e Rotina).
 */
export default function HistoricoCrianca({ alunoId }: { alunoId: number }) {
  const [acaoMsg, setAcaoMsg] = useState('');
  const [enviando, setEnviando] = useState(false);

  const imprimir = async () => {
    setAcaoMsg('');
    try {
      const { data } = await api.get<{ html: string }>(`/alunos/${alunoId}/historico/relatorio`);
      const win = window.open('', '_blank');
      if (!win) { setAcaoMsg('Permita pop-ups para imprimir o histórico.'); return; }
      win.document.write(data.html);
      win.document.close();
      win.focus();
      setTimeout(() => win.print(), 400);
    } catch {
      setAcaoMsg('Não foi possível gerar o histórico para impressão.');
    }
  };

  const enviarEmail = async () => {
    setAcaoMsg('');
    const { data: rel } = await api
      .get<{ responsavelEmail: string | null }>(`/alunos/${alunoId}/historico/relatorio`)
      .catch(() => ({ data: { responsavelEmail: null } }));
    const alvo = rel?.responsavelEmail;
    if (!alvo) { setAcaoMsg('Cadastre o e-mail do responsável antes de enviar.'); return; }
    if (!window.confirm(`Enviar o histórico (PDF anexo) exclusivamente para o e-mail do responsável (${alvo})?`)) return;
    setEnviando(true);
    try {
      const { data } = await api.post<{ destino: string }>(`/alunos/${alunoId}/historico/enviar-email`);
      setAcaoMsg(`✓ Histórico enviado para ${data.destino}.`);
    } catch (e: any) {
      setAcaoMsg(e?.response?.data?.message || 'Falha ao enviar o e-mail.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', border: '1px solid #e6e6e6', borderRadius: 10, padding: 12, background: '#fafafa' }}>
      <button type="button" onClick={imprimir} style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid #ccc', background: '#fff', cursor: 'pointer' }}>🖨️ Imprimir histórico</button>
      <button type="button" onClick={enviarEmail} disabled={enviando} style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid #1565c0', background: '#e3f2fd', color: '#1565c0', cursor: 'pointer', fontWeight: 600 }}>
        {enviando ? 'Enviando…' : '✉️ Enviar ao responsável'}
      </button>
      <span style={{ fontSize: 12, color: '#888' }}>Opcional — a creche decide se compartilha com a família.</span>
      {acaoMsg && <span style={{ fontSize: 13, color: acaoMsg.startsWith('✓') ? '#2e7d32' : '#c62828', flexBasis: '100%' }}>{acaoMsg}</span>}
    </div>
  );
}
